import { render, staticRenderFns } from "./ProjectsPanelProjectsActions.vue?vue&type=template&id=088f366b&"
import script from "./ProjectsPanelProjectsActions.vue?vue&type=script&lang=js&"
export * from "./ProjectsPanelProjectsActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports